import React from 'react';

export type Context = {
    setZoom: ChartZoomProvider['setZoom'];
    getZoom: ChartZoomProvider['getZoom'];
    resetZoom: ChartZoomProvider['resetZoom'];
    setZoomableInstance: ChartZoomProvider['setZoomableInstance'];
};

const ChartZoomContext = React.createContext<Context>({} as any);

type Props = {
    initialZoom: number;
    minZoomLevel: number;
    echartsMapKey: string;
};

export type State = Context;

class ChartZoomProvider extends React.Component<Props, State> {
    static defaultProps = {
        initialZoom: 0.8,
        minZoomLevel: 0.4,
        echartsMapKey: 'world',
    };

    zoomableInstance = null;

    setZoomableInstance = (instance) => {
        this.zoomableInstance = instance;
        this.resetZoom();
    };

    resetZoom = () => {
        this.setZoom(this.props.initialZoom, true);
    };

    setZoom = (zoom: number, reset: boolean = false) => {
        if (!this.zoomableInstance?.setOption) {
            return null;
        }

        const { minZoomLevel } = this.props;
        this.zoomableInstance.setOption({
            series: [
                {
                    type: 'map',
                    map: this.props.echartsMapKey,
                    zoom: zoom < minZoomLevel ? minZoomLevel : zoom,
                    ...(reset && { center: null }),
                },
            ],
        });
    };

    getZoom = () =>
        this.zoomableInstance && this.zoomableInstance.getOption
            ? this.zoomableInstance.getOption().series[0].zoom
            : this.props.initialZoom;

    state: State = {
        setZoom: this.setZoom,
        getZoom: this.getZoom,
        resetZoom: this.resetZoom,
        setZoomableInstance: this.setZoomableInstance,
    };

    render() {
        return (
            <ChartZoomContext.Provider value={{ ...this.state }}>
                {this.props.children}
            </ChartZoomContext.Provider>
        );
    }
}

export default ChartZoomProvider;

const { Consumer } = ChartZoomContext;

export { Consumer as ChartZoomConsumer, ChartZoomContext };
